@switch (dialogDataTemplate) {
  @case (TEMPLATE.DISALLOWED_STATES) {
    <ng-container *ngTemplateOutlet="disallowedStates"></ng-container>
  }

  @case (TEMPLATE.TRIP_COST_EXCEEDS_LIMIT) {
    <ng-container *ngTemplateOutlet="tripCostExceedsLimit"></ng-container>
  }
}

<ng-template #disallowedStates>
  <div class="disallowed-states">
    The TripWise Travel Protection Plan is not available in NY, MT, or WA. If
    you would like to continue to search for a plan on your own that are
    available in those ⁠states, please
    <a
      [href]="links.independentSearch"
      target="_blank"
      class="disallowed-states__link"
    >
      click here
    </a>
    . If you would like us to help you “shop the market” and find the best fit
    for you,
    <a
      [href]="links.assistedSearch"
      target="_blank"
      class="disallowed-states__link"
    >
      click here
    </a>
    to send us your information and we will reach out to you.
  </div>
</ng-template>

<ng-template #tripCostExceedsLimit>
  <div class="disallowed-states">
    The TripWise Travel Protection Plan is not available in NY, MT, or WA.The
    maximum trip cost per person that can be insured is $100,000. If you would like
    to continue to search for a plan on your own that you are eligible for,
    please
    <a
      [href]="links.independentSearch"
      target="_blank"
      class="disallowed-states__link"
    >
      click here
    </a>
    . If you would like us to help you “shop the market” and find the best fit
    for you,
    <a
      [href]="links.assistedSearch"
      target="_blank"
      class="disallowed-states__link"
    >
      click here
    </a>
    to send us your information and we will reach out to you.
  </div>
</ng-template>
